import { SystemStyleObject } from '@chakra-ui/styled-system';

const SidebarTheme = {
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
    } as SystemStyleObject,
  },
};

export default SidebarTheme;
